import React from 'react';
import { FaFacebookF, FaLinkedinIn } from "react-icons/fa";
import { MdEmail, MdLocationOn, MdPhone } from "react-icons/md";
import logo from "../assets/images/logo1.svg";
import { Clock } from 'lucide-react';

import fondo from "../assets/images/fondo_futer.png"; // Asegúrate de que la imagen exista en la ruta correcta

function FooterApp() {
  return (
    <footer className="relative text-blanco py-10">
      {/* Capa de fondo con imagen */}
      <div
        className="absolute inset-0 bg-cover bg-center opacity-50 transition-opacity duration-300 hover:opacity-80"
        style={{ backgroundImage: `url(${fondo})` }}
      ></div>

      {/* Contenido del Footer */}
      <div className="relative container mx-auto px-6 grid grid-cols-1 md:grid-cols-4 gap-6 text-sm">
        
        {/* Logo y Redes Sociales */}
        <div className="flex flex-col items-center md:items-start text-black">
          <img src={logo} alt="Logo" className="w-28 mb-2" />
          <p className="text-justify md:text-left text-xs">
          Somos líderes en certificación y capacitación de maquinaria pesada, equipos de izaje y operadores.
          </p>
          <h3 className="font-bold mt-3  text-azul-oscuro">SÍGUENOS</h3>
          <div className="flex gap-3 mt-2">
            <a href="https://www.facebook.com/cecompperu.training/" className="hover:text-azul-oscuro transition">
              <FaFacebookF size={20} />
            </a>
            <a href="https://www.linkedin.com/in/cecomp-peru-42473014a/" className="hover:text-azul-oscuro transition">
              <FaLinkedinIn size={20} />
            </a>
          </div>
        </div>

        {/* Accesos Rápidos */}
        <div>
          <h3 className="font-bold mb-2 text-azul-oscuro">ACCESOS RÁPIDOS</h3>
          <ul className="space-y-1 text-black">
            <li><a href="/" className="hover:text-azul-oscuro transition">➢ Inicio</a></li>
            <li><a href="/nosotros" className="hover:text-azul-oscuro transition">➢ Nosotros</a></li>
            <li><a href="/servicios" className="hover:text-azul-oscuro transition">➢ Servicios</a></li>
            <li><a href="/perú" className="hover:text-azul-oscuro transition">➢ Contacto</a></li>
            
          </ul>
        </div>

        {/* Contacto */}
        <div>
          <h3 className="font-bold mb-2 text-azul-oscuro">CONTÁCTANOS</h3>
          <p className="flex items-center gap-2 text-black"><MdPhone /> 992100857
          </p>
          <p className="flex items-center gap-2 text-black"><MdPhone /> 959118503</p>
          <p className="flex items-center gap-2 text-black"><MdPhone /> +51 (76) 609440</p>
          <h3 className="font-bold flex items-center gap-2 py-1 text-azul-oscuro"> <Clock />HORARIO</h3>
          <h2 className=" flex items-center gap-2 py-1 px-1 text-black"> Lunes - Viernes</h2>
          <h1 className=" flex items-center gap-2 px-1 text-black"> 8:00 am - 6:00 pm</h1>
        </div>

        {/* Escribir y Ubicación */}
        <div>
          <h3 className="font-bold mb-2 text-azul-oscuro">ESCRÍBENOS</h3>
          <p className="flex items-center gap-2 text-black"><MdEmail /> informes@cecompperu.com</p>
          <p className="flex items-center gap-2 text-black"><MdEmail /> ventas@cecompperu.com</p>
          <h3 className="font-bold mt-3 text-azul-oscuro  text-azul-oscuro">UBÍCANOS</h3>
          <p className="flex items-center gap-2 text-black"><MdLocationOn /> Mariano de los Santos 115 - San Isidro,Lima.</p>
        </div>

      </div>
    </footer>
  );
}

export default FooterApp;
